module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-003.ef8c9509.png";